import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "6",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 .732c.003.043.003.054.01.096a.7.7 0 0 0 .197.38l4.25 4.251c.032.03.04.038.074.064a.71.71 0 0 0 .856 0c.034-.026.041-.035.072-.064l4.25-4.25c.03-.032.038-.039.064-.073A.71.71 0 0 0 9.85.404a.714.714 0 0 0-.854-.371.7.7 0 0 0-.214.11c-.034.026-.042.035-.073.064l-3.75 3.75L1.21.206 1.174.174C1.14.147 1.133.139 1.097.116A.71.71 0 0 0 .01.588C.003.63.003.64 0 .684z"
    }, null, -1)
  ]))]))
}
export default { render: render }